<div class="editor-container">
  <div class="toolbar" style="position: relative">
    <dx-select-box
      [dataSource]="fontSizes"
      [(value)]="currentFontSize"
      height="40"
      width="80"
      (onItemClick)="execute('setFontSize', $event.itemData)"
      i18n-title="@@fontSize"
      title="Font Size"
    >
    </dx-select-box>

    <dx-color-box
      [value]="currentFontColor"
      [editAlphaChannel]="true"
      width="70"
      [inputAttr]="{ 'aria-label': 'With alpha channel editing' }"
      (onValueChanged)="onColorChanged($event)"
      i18n-title="@@fontColor"
      title="Font Color"
    >
    </dx-color-box>

    <span class="toolbar-separator"></span>

    <!-- Font Stuff -->
    <button
      (click)="
        activeTextModifications.bold = !activeTextModifications.bold;
        execute('toggle-bold')
      "
      [class.active]="activeTextModifications.bold == true"
      i18n-title="@@font"
      title="Font"
    >
      <app-svg-icon
        icon="bold"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button
      (click)="
        activeTextModifications.italic = !activeTextModifications.italic;
        execute('toggle-italic')
      "
      [class.active]="activeTextModifications.italic == true"
      i18n-title="@@italic"
      title="Italic"
    >
      <app-svg-icon
        icon="italic"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button
      (click)="
        activeTextModifications.underline = !activeTextModifications.underline;
        execute('toggle-underline')
      "
      [class.active]="activeTextModifications.underline == true"
      i18n-title="@@underline"
      title="Underline"
    >
      <app-svg-icon
        icon="underline"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>

    <span class="toolbar-separator"></span>

    <!-- Alignment -->
    <button (click)="execute('alignLeft')" i18n-title="@@alignLeft" title="Align Left">
      <app-svg-icon
        icon="align-left"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('alignCenter')" i18n-title="@@alignCenter" title="Align Center">
      <app-svg-icon
        icon="align-center"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('alignRight')" i18n-title="@@alignRight" title="Align Right">
      <app-svg-icon
        icon="align-right"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>

    <span class="toolbar-separator"></span>

    <!-- Lists -->
    <button (click)="execute('orderedList')" i18n-title="@@orderedList" title="Ordered List">
      <app-svg-icon
        icon="ordered-list"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('bulletList')" i18n-title="@@bulletList" title="Bullet List">
      <app-svg-icon
        icon="bullet-list"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('taskList')" i18n-title="@@taskList" title="Task List">
      <app-svg-icon
        icon="check-list"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>

    <span class="toolbar-separator"></span>

    <button (click)="execute('addImage')" i18n-title="@@addImage" title="Add Image">
      <app-svg-icon
        icon="image"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('addLink')" i18n-title="@@addLink" title="Add Link">
      <app-svg-icon
        icon="link"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>

    <span class="toolbar-separator"></span>

    <dx-tag-box
      [items]="sparkTags"
      width="300"
      displayExpr="name"
      valueExpr="id"
      [(value)]="spark.tags"
      [multiline]="false"
      [searchEnabled]="true"
      [showDropDownButton]="true"
      [showSelectionControls]="true"
      i18n-placeholder="@@selectTag..."
      placeholder="Select Tag..."
      tagTemplate="tagTemplate"
      itemTemplate="itemTemplate"
      dropDownButtonTemplate="dropDownButtonTemplate"
      class="html-editor-tag-box"
      i18n-title="@@tags"
      title="Tags"
    >
      <div *dxTemplate="let data of 'tagTemplate'">
        <span
          class="spark-tag"
          [style]="{
            'background-color':
              data.color?.background || 'var(--color-secondary)',
            color: data.color?.text || 'var(--color-text-primary)',
            'border-color': data.color?.border || 'var(--color-secondary)',
          }"
          >{{ data.name }}</span
        >
      </div>
      <div *dxTemplate="let data of 'itemTemplate'">
        <span
          class="spark-tag"
          [style]="{
            'background-color':
              data.color?.background || 'var(--color-secondary)',
            color: data.color?.text || 'var(--color-text-primary)',
            'border-color': data.color?.border || 'var(--color-secondary)',
          }"
          >{{ data.name }}</span
        >
      </div>
      <div *dxTemplate="let data of 'dropDownButtonTemplate'">
        <app-svg-icon
          icon="chevron-down"
          [size]="24"
          [strokeWidth]="2"
          class="answer-dropdown-icon"
          color="var(--color-grey-900)"
        ></app-svg-icon>
      </div>
    </dx-tag-box>

    <span class="toolbar-separator"></span>

    <!-- Tables -->
    <button #tableButton (click)="toggleTablePicker(tableButton)" i18n-title="@@table" title="Table">
      <app-svg-icon
        icon="table-insert"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('addRow')" i18n-title="@@addRow" title="Add Row">
      <app-svg-icon
        icon="row-insert"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('deleteRow')" i18n-title="@@deleteRow" title="Delete Row">
      <app-svg-icon
        icon="row-delete"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('addCol')" i18n-title="@@addCol" title="Add Column">
      <app-svg-icon
        icon="column-insert"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('deleteCol')" i18n-title="@@deleteCol" title="Delete Column">
      <app-svg-icon
        icon="column-delete"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>
    <button (click)="execute('deleteTable')" i18n-title="@@deleteTable" title="Delete Table">
      <app-svg-icon
        icon="table-delete"
        [strokeWidth]="toolbarIconStrokeWidth"
      ></app-svg-icon>
    </button>

    <div
      class="table-picker"
      *ngIf="showTablePicker"
      [ngStyle]="{
        top: popupPosition.top + 'px',
        left: popupPosition.left + 'px',
        position: 'absolute',
        zIndex: 100,
      }"
    >
      <div class="grid">
        <div class="row" *ngFor="let r of rows; let rowIndex = index">
          <div
            class="cell"
            *ngFor="let c of cols; let colIndex = index"
            (mouseenter)="hoverTableSize(rowIndex + 1, colIndex + 1)"
            (click)="insertTable(rowIndex + 1, colIndex + 1)"
            [class.selected]="isSelected(rowIndex + 1, colIndex + 1)"
          ></div>
        </div>
      </div>
      <p class="size-label">{{ hoveredRows }} x {{ hoveredCols }} table</p>
    </div>
  </div>

  <tiptap-editor height="300px" [editor]="editor"></tiptap-editor>
</div>
<div class="editor-footer">
  <!-- Action buttons -->
  <div class="edit-actions">
    <app-gpd-button
      i18n-text="@@cancel"
      text="Cancel"
      type="secondary"
      icon="cancel"
      style="margin: 10px 10px 0px 0px"
      (click)="onCancelClick()"
    ></app-gpd-button>
    <app-gpd-button
      i18n-text="@@save"
      text="Save"
      icon="sent"
      style="margin: 10px 10px 0px 0px"
      [disabled]="isLoading()"
      (click)="onSaveClick()"
    ></app-gpd-button>
  </div>
</div>
